import IdentifyAssetForm from "./IdentifyAssetForm";
export default IdentifyAssetForm;
